import { createAction } from '@ngrx/store';

// TODO: Move other epub controls actions here
export const annotateSelectionOnMobile = createAction('Annotate Selection on Mobile');

export type EpubControlsActions = ReturnType<typeof annotateSelectionOnMobile>;
